module.exports = __webpack_public_path__ + "img/DFollowerIcon.1aa989d1.svg";